import { gql } from '@apollo/client';
import {
  Button,
  Card,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@apollo/orbit';
import React, { useState } from 'react';
import { Redirect } from 'react-router';

import { logoutRouteConfig } from 'src/app/onboarding/routes';
import { PostDeleteFeedbackModal } from 'src/components/common/postDeleteFeedbackModal/PostDeleteFeedbackModal';
import { GraphQLTypes } from 'src/lib/graphqlTypes';

import { DeleteUserModal } from '../DeleteUserModal/DeleteUserModal';

export const DeleteUserCardUserFragment = gql`
  fragment DeleteUserCardUserFragment on User {
    id
    email
  }
`;

type DeletionState =
  | 'no desire to delete account'
  | 'user wants to delete account'
  | 'account has been deleted, asked to provide feedback'
  | 'deleted user should be logged out';

interface Props {
  user: GraphQLTypes.DeleteUserCardUserFragment;
}
export function DeleteAccountCard({ user: { id, email } }: Props) {
  const [deletionState, setDeletionState] = useState<DeletionState>(
    'no desire to delete account',
  );

  if (deletionState === 'deleted user should be logged out') {
    return <Redirect to={logoutRouteConfig.location({})} />;
  }

  return (
    <>
      <Card>
        <CardHeader>
          <CardTitle>Delete account</CardTitle>
          <CardDescription>
            Delete your user account and remove yourself from all organizations.{' '}
            <em>This cannot be undone</em>.
          </CardDescription>
          <Button
            variant="destructive"
            onClick={() => setDeletionState('user wants to delete account')}
          >
            Delete my account
          </Button>
        </CardHeader>
      </Card>
      {deletionState === 'user wants to delete account' && (
        <DeleteUserModal
          isOpen
          userId={id}
          onCancel={() => setDeletionState('no desire to delete account')}
          onComplete={() => {
            setDeletionState(
              'account has been deleted, asked to provide feedback',
            );
          }}
        />
      )}
      {deletionState ===
        'account has been deleted, asked to provide feedback' && (
        <PostDeleteFeedbackModal
          isOpen
          targetType={GraphQLTypes.DeletionTargetType.USER}
          targetIdentifier={id.startsWith('fp.') && email !== null ? email : id}
          onComplete={() => {
            setDeletionState('deleted user should be logged out');
          }}
        />
      )}
    </>
  );
}
